import React, {useEffect, useState} from 'react';

import {getDocumentTypes} from "root/Forms/UI/DropdownDataProviders";
import { renderDropdown, renderDropdownReadOnly} from "../DropdownFunctions";
import SpinnerDiv from "../SpinnerDiv";
import PropTypes from "prop-types";

const DropdownDocumentTypes = (props ) =>
{
    const [ data, setData ] = useState ( { loading: true, items : [] } ) ;

    useEffect(() => {
        getDocumentTypes(false).then (response =>
        {
            setData ( { loading: false, items: response }) ;
        })
    }, []);

    return data.loading === true ? <SpinnerDiv/> :
    (
        props.readOnly === 'readonly' ? renderDropdownReadOnly(props, data) : renderDropdown(props, data)
    )
}

export default DropdownDocumentTypes;

DropdownDocumentTypes.defaultProps =
{
    defaultClassName: 'form-group'
}

DropdownDocumentTypes.propTypes = {
    onChange: PropTypes.func.isRequired
};